module.exports = __webpack_public_path__ + "img/plan-04.c5809266.png";